import { render, staticRenderFns } from "./MfaForm.vue?vue&type=template&id=27ee49be&scoped=true"
import script from "./MfaForm.vue?vue&type=script&lang=js"
export * from "./MfaForm.vue?vue&type=script&lang=js"
import style0 from "./MfaForm.vue?vue&type=style&index=0&id=27ee49be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee49be",
  null
  
)

export default component.exports